import React, { Component } from 'react';
import { SOList } from './NametagApproval/componentChildren/SOList';
import { SOItemList } from './NametagApproval/componentChildren/SOItemList';
import { Loader } from './Widgets/Loader';
import './NametagApproval/css/nametagApproval.css';
import { DialogMessage } from './Widgets/DialogMessage';
import { faRefresh} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export class NametagApproval extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: true,
            nametagSOList: [],
            stage: '',
            activeSO: ''
        };
        this.resetState = this.resetState.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.startLoading = this.startLoading.bind(this);
        this.stopLoading = this.stopLoading.bind(this);
        this.displayError = this.displayError.bind(this);
        this.getNametagsToApprove = this.getNametagsToApprove.bind(this);
        this.getNametagsToApproveCallback = this.getNametagsToApproveCallback.bind(this);
        this.startApprovalProcess = this.startApprovalProcess.bind(this);
        this.approveSO = this.approveSO.bind(this);
        this.returnToSOList = this.returnToSOList.bind(this);
        
        this.getNametagsToApprove();
    }

    resetState() {
        this.setState({
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false,
            nametagSOList: []
        });
    }

    closeDialog() {
        this.setState({
            showDialog: false,
            dialogFullScreen: false,
            dialogContent: "",
            dialogTitle: "",
            isErrorMessage: false
        });
    }

    startLoading() {
        this.setState({
            loading: true
        });
    }

    stopLoading() {
        this.setState({
            loading: false
        });
    }

    displayError(title, message) {
        this.setState({
            dialogContent: message,
            dialogTitle: title,
            showDialog: true,
            isErrorMessage: true,
            actionDialog: false
        });
    }

    getNametagsToApprove() {
        this.startLoading();
        setTimeout(this.getNametagsToApproveCallback);
    }

    async getNametagsToApproveCallback() {
        //Get all nametags that need to be approved
        await this.props.makeRESTCall(
            'wmsnametagapproval?',
            'get',
            null,
            (getNametagInfo) => {
                if (getNametagInfo.success) {
                    console.log("INFO", getNametagInfo);
                    this.setState({
                        nametagSOList: getNametagInfo.nametagSOList,
                        stage: 'SOList'
                    })
                } else {
                    this.stopLoading();
                    this.displayError("There was an error getting the nametag info, Please contact I.T.", getNametagInfo.message);
                }
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {
                this.stopLoading();
            }
        );
    }

    startApprovalProcess(SOId) {
        this.setState({
            stage: 'approveSO',
            activeSO: SOId
        })
    }

    approveSO(SOInfo) {
        this.startLoading();
        setTimeout(() => {
            this.approveSOCallback(SOInfo);
        });
    }

    async approveSOCallback(SOInfo) {
        var postBody = {
            SOId: SOInfo.SOId,
            SOPId: SOInfo.SOPId
        };
        await this.props.makeRESTCall(
            'wmsnametagapproval',
            'post',
            postBody,
            (approveSOInfo) => {
                console.log("APPROVE SO INFO", approveSOInfo);
                var nametagSOList = this.state.nametagSOList;
                for (var i in nametagSOList) {
                    if (nametagSOList[i].SOId == SOInfo.SOId) {
                        nametagSOList[i].approved = true;
                        break;
                    }
                }
                this.setState({
                    nametagSOList: nametagSOList,
                    stage: 'SOList',
                })
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {
                this.stopLoading();
            }
        );
    }

    async returnToSOList(SOId) {
        var nametagSOList = this.state.nametagSOList;
        for (var i in nametagSOList) {
            if (nametagSOList[i].SOId == SOId) {
                nametagSOList[i].viewed = true;
                await this.markNametagIssue(nametagSOList[i].SOPId);
                //Move to bottom of list
                var SOInfo = nametagSOList[i];
                nametagSOList.splice(i, 1);
                nametagSOList.push(SOInfo);
                break;
            }
        }
        this.setState({
            stage: 'SOList',
            activeSO: ''
        });
    }

    async markNametagIssue(SOPId) {
        //Make REST call to mark nametag
        var postBody = {
            SOPId: SOPId,
            markIssue: true
        };
        await this.props.makeRESTCall(
            'wmsnametagapproval',
            'post',
            postBody,
            (markUnapprovedInfo) => {
                console.log("markUnapprovedInfo", markUnapprovedInfo);
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {
                this.stopLoading();
            }
        );
    }

    render() {
        return (
            <div>
                {this.state.loading && <Loader />}
                <DialogMessage
                    closeDialog={this.closeDialog}
                    showDialog={this.state.showDialog}
                    dialogTitle={this.state.dialogTitle}
                    dialogContent={this.state.dialogContent}
                    isErrorMessage={this.state.isErrorMessage}
                    dialogFullScreen={this.state.dialogFullScreen}
                />
                <div className="nametag-validation">
                    {
                        this.state.stage === 'SOList'
                        &&
                        <div className="nametag-order-approval-so-list">
                                <h1> Nametag Order Approval <FontAwesomeIcon className="imageIcon" onClick={this.getNametagsToApprove} size="lg" icon={faRefresh} /></h1>
                                <SOList
                                    nametagSOList={this.state.nametagSOList}
                                    startApprovalProcess={this.startApprovalProcess}
                                />
                        </div>
                    }
                    {
                        this.state.stage == 'approveSO'
                        &&
                        <SOItemList
                            nametagSOList={this.state.nametagSOList}
                            activeSO={this.state.activeSO}
                            activeItemIndex={this.state.activeItemIndex}
                            approveSO={this.approveSO}
                            returnToSOList={this.returnToSOList}
                        />
                    }
                </div>
            </div>
        );
    }
}
